<div class="white-bg surface-primary" [ngClass]="containerClasses()">
  @if (title() || endTitle()) {
    <h2 class="font-heading-4 flex flex--center flex--space-between font-title-medium" [ngClass]="headerClasses()">
      <span class="block">{{ title() }}</span>
      <span class="block {{ endTitleClasses() }}">{{ endTitle() }}</span>
    </h2>
  }
  @if (!noContent()) {
    <div class="flex section-list">
      <ng-content select="content" />
    </div>
  }
  @if (!noButton()) {
    <div class="align-right font-body-1 font-body-medium">
      <ng-content select="button" />
    </div>
  }
</div>
